var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiteratureRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 121,
    viewBox: "0 0 219 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.798 49.4081L104.711 47.8066L103.109 51.8941L107.197 53.4956L108.798 49.4081Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.76 51.5698C179.636 51.5698 186.02 45.1854 186.02 37.3098C186.02 29.4342 179.636 23.0498 171.76 23.0498C163.884 23.0498 157.5 29.4342 157.5 37.3098C157.5 45.1854 163.884 51.5698 171.76 51.5698Z",
    fill: "#9775FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 49.7202C180.376 49.7202 186.76 43.3358 186.76 35.4602C186.76 27.5846 180.376 21.2002 172.5 21.2002C164.625 21.2002 158.24 27.5846 158.24 35.4602C158.24 43.3358 164.625 49.7202 172.5 49.7202Z",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.49 38.8503C171.65 41.7503 177.36 40.7303 180.26 36.5703",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.03 26.4404L166.05 28.8204L169.73 27.6804L168.4 31.2904L170.62 34.4304L166.77 34.2804L164.47 37.3604L163.42 33.6604L159.78 32.4204L162.98 30.2804L163.03 26.4404Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.67 25.29L176.45 24.57L177.99 21.04L179.85 24.41L183.68 24.79L181.05 27.6L181.87 31.36L178.39 29.72L175.07 31.67L175.54 27.85L172.67 25.29Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.923 110.145V71.1348H159.463V110.145H168.923Z",
    fill: "#5F3DC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.468 110.146V56.9561H141.738V110.146H159.468Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.734 110.145V42.7646H134.644V110.145H141.734Z",
    fill: "#5F3DC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.149 62.8604H159.469",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.739 62.8604H150.599",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.64 46.3096H141.74",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.64 48.6797H141.74",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.64 99.5H141.74",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.649 88.8701H167.739",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.649 92.4102H167.739",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.09 65.2305H159.47",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.739 65.2305H150.599",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.739 106.6H159.469",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.739 104.23H159.469",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.05 56.9502L150.01 80.5902L152.48 76.8402C152.48 76.8402 153.63 80.5902 154.18 80.5902C154.55 80.5902 154.93 70.1102 155.15 63.1002C155.26 59.5902 155.32 56.9502 155.32 56.9502",
    fill: "#F1ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.64 110.145V58.1348H127.26L127.26 110.145H134.64Z",
    fill: "#9775FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.259 110.148L127.259 68.6182H113.419V110.148H127.259Z",
    fill: "#6741D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.416 110.134V78.2236H99.176V110.134H113.416Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.42 73.2295H127.26",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 83.4297H113.42",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1797 101.84H113.42",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.18 61.6201H133.72",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.18 96.2998H133.72",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.42 75.0801H127.26",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.42 107.37H127.26",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.42 105.529H127.26",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.03 26.2798V2.00977H103.25V26.2798L96.3701 39.1698L115.04 26.9098H137.68",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9498 59.9499L5.36987 52.1699L1.41992 60.8999L10.9498 59.9499Z",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5398 10.9896C78.5898 10.6596 78.7697 10.3496 79.0697 10.1296C79.6597 9.69958 80.4798 9.82958 80.8998 10.4196L82.8998 13.1796C83.3298 13.7696 83.1997 14.5896 82.6097 15.0096C82.0197 15.4396 81.1998 15.3096 80.7798 14.7196L78.7798 11.9596C78.5598 11.6796 78.4898 11.3296 78.5398 10.9896Z",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.88 2.62012L200.12 11.3801",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.12 12.8799L191.88 25.3799",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.2 57.9499L210.62 50.1699L206.67 58.8999L216.2 57.9499Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4497 105.71C21.8194 105.71 22.9298 104.6 22.9298 103.23C22.9298 101.86 21.8194 100.75 20.4497 100.75C19.08 100.75 17.9697 101.86 17.9697 103.23C17.9697 104.6 19.08 105.71 20.4497 105.71Z",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.88 107.12L183.12 90.8799",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.38 117.12L184.38 102.12",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.41 62.61H40.71V59.64L68.75 57.75L68.41 62.61Z",
    fill: "#D0BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8096 28.8303L52.0195 21.5303L62.4995 36.5003L42.2795 54.0003L42.4895 45.1903L36.2495 36.5003L32.8096 28.8303Z",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1201 3.38049C38.1201 3.38049 26.4101 5.82049 27.8901 17.7205C29.3701 29.6305 36.5001 38.5605 43.5601 35.3405C46.0301 34.2105 47.9101 32.0405 50.0301 30.5305C57.5001 25.2505 55.35 16.8105 55.35 16.8105C55.35 16.8105 54.3801 0.880487 38.1201 3.38049Z",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4001 119.001H32.1901C30.3601 119.001 28.8701 117.511 28.8701 115.681V113.791C28.8701 111.961 30.3601 110.471 32.1901 110.471H82.4001C84.2301 110.471 85.7201 111.961 85.7201 113.791V115.681C85.7201 117.511 84.2401 119.001 82.4001 119.001Z",
    fill: "#D0BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0399 110.25H39.3799C38.1599 110.25 37.1699 109.26 37.1699 108.04V106.53C37.1699 105.31 38.1599 104.32 39.3799 104.32H74.0399C75.2599 104.32 76.2499 105.31 76.2499 106.53V108.04C76.2499 109.26 75.2599 110.25 74.0399 110.25Z",
    fill: "#D0BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0396 77.1006V103.841H43.5596V77.1006",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6895 76.3701H66.8995",
    stroke: "#7950F2",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9701 78.2501C74.8901 78.2501 75.6401 77.5001 75.6401 76.5801C75.6401 75.4301 74.7002 74.4901 73.5502 74.4901C72.1102 74.4901 70.9401 75.6601 70.9401 77.1001C70.9401 78.9001 72.4001 80.3701 74.2101 80.3701C76.4701 80.3701 78.2902 78.5401 78.2902 76.2901C78.2902 73.4701 76.0001 71.1901 73.1901 71.1901C69.6701 71.1901 66.8102 74.0501 66.8102 77.5701C66.8102 81.9701 70.3802 85.5501 74.7902 85.5501C80.3002 85.5501 84.7601 81.0901 84.7601 75.5801C84.7601 68.7001 79.1802 63.1201 72.3002 63.1201H42.3301C35.4501 63.1201 29.8701 68.7001 29.8701 75.5801C29.8701 81.0901 34.3301 85.5501 39.8401 85.5501C41.1901 85.5501 42.4701 85.2101 43.5801 84.6201C46.1001 83.2801 47.8102 80.6301 47.8102 77.5701C47.8102 77.1601 47.7701 76.7601 47.7001 76.3801C47.1401 73.4301 44.5502 71.1901 41.4302 71.1901C38.6102 71.1901 36.3301 73.4801 36.3301 76.2901C36.3301 78.5501 38.1602 80.3701 40.4102 80.3701C42.2102 80.3701 43.6802 78.9101 43.6802 77.1001C43.6802 75.6601 42.5101 74.4901 41.0701 74.4901C39.9201 74.4901 38.9801 75.4301 38.9801 76.5801C38.9801 77.5001 39.7301 78.2501 40.6501 78.2501",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9701 78.2501C74.8901 78.2501 75.6401 77.5001 75.6401 76.5801C75.6401 75.4301 74.7002 74.4901 73.5502 74.4901C72.1102 74.4901 70.9401 75.6601 70.9401 77.1001C70.9401 78.9001 72.4001 80.3701 74.2101 80.3701C76.4701 80.3701 78.2902 78.5401 78.2902 76.2901C78.2902 73.4701 76.0001 71.1901 73.1901 71.1901C69.6701 71.1901 66.8102 74.0501 66.8102 77.5701C66.8102 81.9701 70.3802 85.5501 74.7902 85.5501C80.3002 85.5501 84.7601 81.0901 84.7601 75.5801C84.7601 68.7001 79.1802 63.1201 72.3002 63.1201H42.3301C35.4501 63.1201 29.8701 68.7001 29.8701 75.5801C29.8701 81.0901 34.3301 85.5501 39.8401 85.5501C41.1901 85.5501 42.4701 85.2101 43.5801 84.6201C46.1001 83.2801 47.8102 80.6301 47.8102 77.5701C47.8102 77.1601 47.7701 76.7601 47.7001 76.3801C47.1401 73.4301 44.5502 71.1901 41.4302 71.1901C38.6102 71.1901 36.3301 73.4801 36.3301 76.2901C36.3301 78.5501 38.1602 80.3701 40.4102 80.3701C42.2102 80.3701 43.6802 78.9101 43.6802 77.1001C43.6802 75.6601 42.5101 74.4901 41.0701 74.4901C39.9201 74.4901 38.9801 75.4301 38.9801 76.5801C38.9801 77.5001 39.7301 78.2501 40.6501 78.2501",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5596 103.37H48.7695V85.4202C48.7695 84.6102 49.4295 83.9502 50.2395 83.9502H51.0795C51.8895 83.9502 52.5496 84.6102 52.5496 85.4202V103.37H52.5596Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1991 103.37H55.4092V85.4202C55.4092 84.6102 56.0692 83.9502 56.8792 83.9502H57.7191C58.5291 83.9502 59.1891 84.6102 59.1891 85.4202V103.37H59.1991Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.829 103.37H62.0391V85.4202C62.0391 84.6102 62.699 83.9502 63.509 83.9502H64.349C65.159 83.9502 65.819 84.6102 65.819 85.4202V103.37H65.829Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8203 104.471H71.8804",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1201 110.721H80.6201",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1201 119.62H80.6201",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5002 35.25L82.2803 41.08C84.1603 41.44 85.0703 43.59 84.0303 45.2L77.9502 54.54L74.5902 59.15L41.3502 59.67C39.4802 59.7 32.4603 54.98 34.0203 53.44L42.3302 46.26",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9902 7.36044C47.7302 6.61044 44.4002 5.81044 40.1102 5.65044C31.5402 5.33044 28.7402 10.5704 28.7402 10.5704C28.7402 10.5704 29.3102 1.21044 40.1102 0.890441C47.7302 0.670441 51.2403 4.72044 52.6403 7.12044",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2804 17.21C44.6304 17.4 44.8704 17.77 44.8704 18.19C44.8704 18.8 44.3704 19.3 43.7604 19.3C43.1504 19.3 42.6504 18.8 42.6504 18.19C42.6504 17.82 42.8303 17.5 43.1003 17.3",
    fill: "#7950F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6895 19.6104C34.8995 19.8104 35.0295 20.1004 35.0295 20.4104C35.0295 21.0204 34.5296 21.5204 33.9196 21.5204C33.3096 21.5204 32.8096 21.0204 32.8096 20.4104C32.8096 20.1004 32.9295 19.8304 33.1395 19.6204",
    fill: "#7950F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 22.7504C43.76 23.4704 46.78 21.5004 47.5 20.2504L48.75 16.5004L53.13 16.1504C53.13 16.1504 54.38 22.1204 51.88 24.6204C49.38 27.1204 44.88 26.0604 44.88 26.0604L42.5 22.7504Z",
    fill: "#D0BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3495 18.5605C35.6295 19.8105 32.8195 20.3205 31.9395 18.5605H36.3495Z",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3495 18.5605C35.6295 19.8105 32.8195 20.3205 31.9395 18.5605",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6202 18.3809C55.6202 18.3809 56.6002 23.6709 53.7402 25.2609L55.6202 18.3809Z",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0099 31.6807H68.5499L68.3599 32.8107L68.0599 34.5407L60.6499 40.2307C60.3199 40.4807 60.0299 40.7707 59.7699 41.0907L44.0698 59.6407H41.4199L62.0099 31.6807Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6594 30.7305L79.7894 32.0005L79.1494 33.5905L52.6594 59.6405H45.3594L71.6294 32.6705L75.6594 30.7305Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2894 30.02L43.1194 27.79L38.8394 28.51L38.1094 31.79",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2894 30.02L43.1194 27.79L38.8394 28.51L38.1094 31.79",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8499 18.0402C30.3099 17.5302 30.5898 16.8702 30.5898 16.1302C30.5898 15.1502 30.0898 14.2802 29.3398 13.7702C29.8898 13.5202 30.2799 12.9702 30.2799 12.3302C30.2799 11.4502 29.5698 10.7402 28.6898 10.7402C27.8098 10.7402 27.0999 11.4502 27.0999 12.3302C27.0999 12.7002 27.2298 13.0302 27.4398 13.3002C25.9998 13.4502 24.8799 14.6602 24.8799 16.1402C24.8799 17.0302 25.2899 17.8302 25.9299 18.3602C25.4699 18.8702 25.1898 19.5302 25.1898 20.2702C25.1898 21.8502 26.4699 23.1302 28.0499 23.1302C29.6299 23.1302 30.9099 21.8502 30.9099 20.2702C30.9099 19.3602 30.4999 18.5702 29.8499 18.0402Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.33 17.0801L31.54 17.7201",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5598 16.3203C43.8398 17.5703 40.7598 17.5103 39.5098 16.7903L44.5598 16.3203Z",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5598 16.3203C43.8398 17.5703 40.7598 17.5103 39.5098 16.7903",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4398 29.5301C54.2198 28.8601 54.7098 27.8701 54.7098 26.7701C54.7098 24.7501 53.0799 23.1201 51.0599 23.1201C49.0399 23.1201 47.4099 24.7501 47.4099 26.7701C47.4099 27.2801 47.5198 27.7701 47.6998 28.2101C46.6498 28.3001 45.8198 29.1901 45.8198 30.2601C45.8198 31.4001 46.7399 32.3201 47.8799 32.3201C48.0499 32.3201 48.2199 32.3001 48.3799 32.2601C48.3699 32.3901 48.3599 32.5101 48.3599 32.6401C48.3599 32.7501 48.3699 32.8501 48.3799 32.9601C48.3699 32.9601 48.3699 32.9601 48.3599 32.9601C47.7999 32.9601 47.2798 33.1001 46.8298 33.3601C45.9698 32.1601 44.5598 31.3801 42.9698 31.3801C41.7198 31.3801 40.5799 31.8701 39.7299 32.6601C39.6999 32.6601 39.6699 32.6501 39.6299 32.6501C38.8599 32.6501 38.1699 33.1301 37.6799 33.8801C37.3199 32.8901 36.4898 32.1101 35.4598 31.8201C35.7798 31.5001 35.9799 31.0701 35.9799 30.5801C35.9799 29.7201 35.3599 29.0101 34.5399 28.8601C34.8499 28.3601 35.0299 27.7501 35.0299 27.0901C35.0299 25.4201 33.8899 24.0701 32.4899 24.0701C31.0899 24.0701 29.9498 25.4201 29.9498 27.0901C29.9498 28.1201 30.3899 29.0301 31.0499 29.5701C30.2299 29.8401 29.6299 30.6101 29.6299 31.5301C29.6299 32.6201 30.4699 33.5101 31.5399 33.5901C31.3299 34.0201 31.2098 34.5101 31.2098 35.0301C31.2098 36.8601 32.6799 38.3401 34.5099 38.3601C34.3299 38.7701 34.2299 39.2301 34.2299 39.7101C34.2299 41.4201 35.4699 42.8001 37.0099 42.8001C37.3699 42.8001 37.7099 42.7201 38.0199 42.5901C38.3999 43.8201 39.5499 44.7101 40.8999 44.7101C42.0199 44.7101 42.9999 44.1001 43.5199 43.1901C44.1899 44.2901 45.3899 45.0301 46.7699 45.0301C48.8699 45.0301 50.5798 43.3201 50.5798 41.2201C50.5798 40.3701 50.2998 39.5901 49.8298 38.9501C50.8398 38.4201 51.5299 37.3601 51.5299 36.1401C51.5299 36.1301 51.5299 36.1301 51.5299 36.1201C51.6299 36.1301 51.7399 36.1401 51.8499 36.1401C53.7799 36.1401 55.3398 34.5801 55.3398 32.6501C55.3498 31.2801 54.5698 30.1101 53.4398 29.5301Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75 7.75L46.25 14V15.25L49.53 18.26C49.53 18.26 54.46 14.74 54.73 15C55 15.26 50 7.75 50 7.75H43.75Z",
    fill: "#D0BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0494 12.0209C54.4594 11.4909 54.7094 10.8309 54.7094 10.1009C54.7094 8.7409 53.8494 7.5709 52.6394 7.1209C52.2994 6.9909 51.9194 6.9209 51.5394 6.9209C50.9594 6.9209 50.4193 7.0709 49.9493 7.3409C48.9993 7.8909 48.3594 8.9109 48.3594 10.0909C48.3594 11.6809 49.5294 12.9909 51.0594 13.2209C50.3694 13.9309 49.9493 14.9009 49.9493 15.9709C49.9493 18.1609 51.7294 19.9409 53.9194 19.9409C56.1094 19.9409 57.8894 18.1609 57.8894 15.9709C57.8894 13.8309 56.1794 12.0909 54.0494 12.0209Z",
    fill: "#B197FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1094 26.4902C38.1094 26.4902 44.2894 26.4902 42.6494 23.6402C41.7194 22.0202 40.1094 22.4702 40.1094 22.4702L39.4794 16.1202L46.1494 14.8502C46.1494 14.8502 47.8194 12.3702 43.4094 11.4902",
    stroke: "#7950F2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiteratureRightImage);
export default __webpack_public_path__ + "static/media/literatureRightImage.7b60bc8ba6442e09113307ec2551d2ec.svg";
export { ForwardRef as ReactComponent };